/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// Billing page components
import DevicesView from "layouts/billing/components/Device";

function Billing() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <MDBox display="flex" justifyContent="center" alignItems="center">
          <DevicesView />
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Billing;
